import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ChatbotFrame from './components/public/ChatbotFrame';
import { AuthProvider } from './contexts/AuthContext';
import { ResellerProvider } from './contexts/ResellerContext';
import ThemeWrapper from './components/base/ThemeWrapper';
import { UserNotificationProvider } from './contexts/UserNotificationContext';
import Cookies from './common/Cookies.js';
import { API_URL } from './common/Constants.js';

// import reportWebVitals from './reportWebVitals';
// import { AlertProvider } from './common/AlertContext.js';

axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.common['Authorization'] = `Bearer ${Cookies.getJwtToken()}`;

// Check URL parameter to determine which root to use
const urlParams = new URLSearchParams(window.location.search);
const isChatMode = urlParams.get('mode') === 'chat';
const isTransparentChat =
  urlParams.get('transparent') === 'true' && urlParams.get('embed') === 'full';

const slickbotsRoot = document.getElementById('slickbots_root');
const chatbotRoot = document.getElementById('chatbot_root');

if (isChatMode && chatbotRoot) {
  // Render ChatbotFrame directly for chat mode (with theme for reseller button colors)
  chatbotRoot.style.width = '100%';
  chatbotRoot.style.height = '100%';
  chatbotRoot.style.position = 'fixed';
  if (isTransparentChat) {
    document.documentElement.style.background = 'transparent';
    document.body.style.background = 'transparent';
    chatbotRoot.style.background = 'transparent';
  }
  const root = ReactDOM.createRoot(chatbotRoot);
  root.render(
    <ResellerProvider>
      <ThemeWrapper>
        <ChatbotFrame />
      </ThemeWrapper>
    </ResellerProvider>
  );
} else if (slickbotsRoot) {
  // Render full App for normal mode
  const root = ReactDOM.createRoot(slickbotsRoot);
  root.render(
    <AuthProvider>
      <UserNotificationProvider>
        <App />
      </UserNotificationProvider>
    </AuthProvider>
    // <AlertProvider>
    //   <App />
    // </AlertProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

